<section class="dashboard-page">
  <header class="dashboard-header">
    <div>
      <p class="eyebrow">{{ 'dashboard.eyebrow' | t }}</p>
      <h1>{{ organisationName() }}</h1>
      <p class="filter-status">{{ 'dashboard.filter.active' | t }}: {{ filterLabel() }}</p>
    </div>
  </header>

  <section class="dashboard-filters" [class.loading]="loadingSummary()">
    <div class="quick-filters" [attr.aria-label]="'dashboard.filter.quickFilters' | t">
      @for (option of periodOptions; track option.value) {
        <button
          mat-stroked-button
          type="button"
          [class.active-filter]="selectedPeriod() === option.value"
          [disabled]="loadingSummary()"
          (click)="applyPeriod(option.value)"
        >
          {{ option.labelKey | t }}
        </button>
      }
    </div>

    <div class="range-actions">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'dashboard.filter.dateRange' | t }}</mat-label>
        <mat-date-range-input [rangePicker]="dashboardRangePicker">
          <input matStartDate [ngModel]="dateFromValue()" (ngModelChange)="onDateFromChange($event)" [placeholder]="'dashboard.filter.dateFrom' | t" />
          <input matEndDate [ngModel]="dateToValue()" (ngModelChange)="onDateToChange($event)" [placeholder]="'dashboard.filter.dateTo' | t" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="dashboardRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dashboardRangePicker></mat-date-range-picker>
      </mat-form-field>
      <button mat-flat-button type="button" [disabled]="loadingSummary() || (!dateFrom() && !dateTo())" (click)="applyDateRange()">
        <mat-icon>date_range</mat-icon>
        {{ 'dashboard.filter.applyRange' | t }}
      </button>
      <button mat-button type="button" [disabled]="loadingSummary() || !hasActiveFilter()" (click)="clearFilters()">
        <mat-icon>filter_alt_off</mat-icon>
        {{ 'dashboard.filter.clear' | t }}
      </button>
    </div>
  </section>

  @if (filterError()) {
    <div class="filter-error">
      <mat-icon>error</mat-icon>
      <span>{{ filterError() }}</span>
    </div>
  }

  <section class="cards-grid">
    @for (card of cards(); track card.title) {
      <a class="dashboard-card-link" [class.overdue-card-link]="card.key === 'overduePayments' && overdueAmount() > 0" [routerLink]="card.route" [attr.aria-label]="card.action" [matTooltip]="card.tooltip ?? ''" [matTooltipDisabled]="!card.tooltip">
        <mat-card class="dashboard-card">
          <mat-card-content>
            <div class="card-topline">
              <div class="card-icon">
                <mat-icon>{{ card.icon }}</mat-icon>
              </div>
              <span class="card-action">{{ card.action }}</span>
            </div>
            <div class="card-body">
              <h2>{{ card.title }}</h2>
              <div class="card-value">{{ card.value }}</div>
              <p>{{ card.caption }}</p>
            </div>
            @if (card.key === 'lessons') {
              <mat-progress-bar mode="determinate" [value]="completedLessonsProgress()" />
            }
          </mat-card-content>
        </mat-card>
      </a>
    }
  </section>

  <section class="lesson-summary" aria-labelledby="lesson-summary-title">
    <mat-card class="lesson-status-card">
      <mat-card-content>
        <div class="section-heading">
          <div>
            <p class="eyebrow">{{ 'dashboard.lessonBreakdown.eyebrow' | t }}</p>
            <h2 id="lesson-summary-title">{{ 'dashboard.lessonBreakdown.title' | t }}</h2>
          </div>
          <span>{{ 'dashboard.lessonBreakdown.total' | t: { hours: formatHours(lessonHours()), count: summary().lessons.total } }}</span>
        </div>
        <div class="status-grid">
          @for (status of lessonStatuses(); track status.key) {
            <div class="status-item" [class]="'status-item ' + status.key">
              <span>{{ ('dashboard.lessonBreakdown.' + status.key) | t }}</span>
              <strong>{{ 'dashboard.lessonBreakdown.hours' | t: { hours: formatHours(status.hours) } }}</strong>
              <small>{{ 'dashboard.lessonBreakdown.count' | t: { count: status.count } }}</small>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="lesson-categories-card">
      <mat-card-content>
        <div class="section-heading">
          <div>
            <p class="eyebrow">{{ 'dashboard.lessonCategories.eyebrow' | t }}</p>
            <h2>{{ 'dashboard.lessonCategories.title' | t }}</h2>
          </div>
        </div>
        <div class="category-table-wrap">
          <table>
            <thead>
              <tr>
                <th>{{ 'dashboard.lessonCategories.category' | t }}</th>
                <th>{{ 'dashboard.lessonCategories.total' | t }}</th>
                <th>{{ 'dashboard.lessonBreakdown.planned' | t }}</th>
                <th>{{ 'dashboard.lessonBreakdown.completed' | t }}</th>
                <th>{{ 'dashboard.lessonBreakdown.cancelled' | t }}</th>
              </tr>
            </thead>
            <tbody>
              @for (category of lessonCategories(); track category.category) {
                <tr>
                  <th>{{ categoryLabel(category.category) }}</th>
                  <td><strong>{{ formatHours(category.durationHours) }} h</strong><small>{{ category.total }}</small></td>
                  <td><strong>{{ formatHours(category.plannedDurationHours) }} h</strong><small>{{ category.planned }}</small></td>
                  <td><strong>{{ formatHours(category.completedDurationHours) }} h</strong><small>{{ category.completed }}</small></td>
                  <td><strong>{{ formatHours(category.cancelledDurationHours) }} h</strong><small>{{ category.cancelled }}</small></td>
                </tr>
              } @empty {
                <tr><td colspan="5" class="empty-row">{{ 'dashboard.lessonCategories.empty' | t }}</td></tr>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
</section>
